module.exports = __webpack_public_path__ + "static/media/cert_112.38e00b26.jpg";